import { Accordion, Button, Card, Carousel, Container } from "react-bootstrap";
import BannerVid from "../src/assets/videos/banner-vid.webm";
import Vid from "../src/assets/videos/video1.webm";
import Vid2 from "../src/assets/videos/video2.webm";
import Firework from "../src/assets/images/firework.png";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import Logo from "../src/assets/images/logo.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import star from "../src/assets/images/star.png";
const getSlidesToShow = (w) => {
  if (w >= 1200) return 4;
  if (w >= 992) return 3;
  if (w >= 768) return 2;
  return 1;
};
function App() {
  const [productList, setProductList] = useState([]);
  const [singleProduct, setSingleProduct] = useState();
  const [selectedColor, setSelectedColor] = useState("Black");
  const [slidesToShow, setSlidesToShow] = useState(
    typeof window !== "undefined" ? getSlidesToShow(window.innerWidth) : 1
  );
  const SHOPIFY_DOMAIN = "contact-wearables.myshopify.com";
  const STOREFRONT_ACCESS_TOKEN = "f611a2be3e7a5bd30736a25296a6e311";

  // const singleProductQuery = `
  //   query getProduct($id: ID!) {
  //     product(id: $id) {
  //       id
  //       title
  //       handle
  //       description
  //       descriptionHtml
  //       productType
  //       tags
  //       vendor
  //       publishedAt
  //       onlineStoreUrl
  //       images(first: 5) {
  //         edges {
  //           node {
  //             url
  //             altText
  //           }
  //         }
  //       }
  //       variants(first: 5) {
  //         edges {
  //           node {
  //             id
  //             title
  //             sku
  //             availableForSale
  //              priceV2 {
  //             amount
  //             currencyCode
  //           }
  //           compareAtPriceV2 {
  //             amount
  //             currencyCode
  //           }
  //           }
  //         }
  //       }
  //     }
  //   }
  // `;

  const singleProductQuery = `
  query getProduct($id: ID!) {
    product(id: $id) {
      id
      title
      handle
      description
      descriptionHtml
      productType
      tags
      vendor
      publishedAt
      onlineStoreUrl
      images(first: 5) {
        edges {
          node {
            url
            altText
          }
        }
      }
      variants(first: 5) {
        edges {
          node {
            id
            title
            sku
            availableForSale
            priceV2 {
              amount
              currencyCode
            }
            compareAtPriceV2 {
              amount
              currencyCode
            }
          }
        }
      }
    }
  }
`;

  // const productListQuery = `
  //   {
  //     products(first: 100) {
  //       edges {
  //         node {
  //           id
  //           title
  //           description
  //           images(first: 5) {
  //             edges {
  //               node {
  //                 url
  //               }
  //             }
  //           }
  //           priceRange {
  //             minVariantPrice {
  //               amount
  //               currencyCode
  //             }
  //             maxVariantPrice {
  //               amount
  //               currencyCode
  //             }
  //           }
  //           onlineStoreUrl  # This will give you the product page URL
  //         }
  //       }
  //     }
  //   }
  // `;

  const productListQuery = `
  {
    products(first: 100) {
      edges {
        node {
          id
          title
          description
          images(first: 5) {
            edges {
              node {
                url
              }
            }
          }
          priceRange {
            minVariantPrice {
              amount
              currencyCode
            }
            maxVariantPrice {
              amount
              currencyCode
            }
          }
          onlineStoreUrl  # This will give you the product page URL
        }
      }
    }
  }
  `;

  const sliderRef = useRef(null);
  const productSliderRef = useRef(null);
  const reviewSliderRef = useRef(null);

  const reviews = [
    {
      name: "Doug Peeler",
      title: "Brilliant networking fun",
      review:
        "Great tool for quick connects at a large conference/venue without having to take out phone or business cards! Look forward to lots of additional connects...",
      rating: 5,
      verified: true,
    },
    {
      name: "Chip Slaughter",
      title: "As Advertised",
      review:
        " I rank products in order of three things: (1) Practical value to me as a user, (2) Price/Value (3) Support. I give Contact Co 5 stars plus on all three. The card is cool with unique backgrounds and numerous color options, the performance is fast and easy, and the support is instant and extremely helpful. In this day and age, you always want to do business with people who are willing to spend time making sure everything works as advertised, and this company checks all of those boxes. Throw away all of your outdated business cards and buy one (or several) of these products.",
      rating: 5,
      verified: true,
    },
  ];
  const settingsReview = {
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    // Wait a tick for layout to stabilize, then refresh
    setTimeout(() => {
      if (sliderRef.current) {
        sliderRef.current.slickGoTo(0); // Force re-render
      }
    }, 200);
  }, []);
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow,
    slidesToScroll: 4,
    mobileFirst: true,
  };

  const announcementSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    pauseOnHover: true,
  };

  const variant = singleProduct?.variants?.edges[0]?.node;

  const originalPrice = parseFloat(
    variant?.compareAtPriceV2?.amount || variant?.priceV2?.amount
  ); 
  const salePrice = parseFloat(variant?.priceV2?.amount);

  const hasDiscount = originalPrice > salePrice;
  const discountPercentage = hasDiscount
    ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
    : 0;

  // useEffect(() => {
  //   // Wait a tick for layout to stabilize, then refresh
  //   setTimeout(() => {
  //     if (productSliderRef.current) {
  //       productSliderRef.current.slickGoTo(0); // Force re-render
  //     }
  //   }, 200);
  // }, []);

  useEffect(() => {
    if (productSliderRef.current) {
      productSliderRef.current.slickGoTo(0); 
    }
  }, [productList]);
  
  useEffect(() => {
    // Wait a tick for layout to stabilize, then refresh
    setTimeout(() => {
      if (reviewSliderRef.current) {
        reviewSliderRef.current.slickGoTo(0); // Force re-render
      }
    }, 200);
  }, []);
  const getSingleProductDetails = async () => {
    try {
      const response = await axios.post(
        `https://${SHOPIFY_DOMAIN}/api/2024-07/graphql.json`,
        {
          query: singleProductQuery,
          variables: {
            id: "gid://shopify/Product/8899949887792", // ✅ Correct format
          },
        },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          },
        }
      );

      setSingleProduct(response.data.data.product);
      console.log("Single product:", response.data.data.product);
    } catch (error) {
      console.error(
        "Error fetching single product:",
        error.response?.data || error.message
      );
    }
  };

  const getProductList = async () => {
    try {
      const response = await axios.post(
        `https://${SHOPIFY_DOMAIN}/api/2024-07/graphql.json`,
        { query: productListQuery },
        {
          headers: {
            "Content-Type": "application/json",
            "X-Shopify-Storefront-Access-Token": STOREFRONT_ACCESS_TOKEN,
          },
        }
      );

      setProductList(response?.data?.data?.products?.edges);
      console.log("Product list:", response.data.data.products.edges);
    } catch (error) {
      console.error(
        "Error fetching product list:",
        error.response?.data || error.message
      );
    }
  };

  const settingsImg = {
    customPaging: function (i) {
      const imgUrl =
        singleProduct?.images?.edges?.[i]?.node?.url ||
        "https://via.placeholder.com/100";
      return (
        <a>
          <img
            src={imgUrl}
            alt={`Thumbnail ${i + 1}`}
            style={{ width: "60px", borderRadius: "6px" }}
          />
        </a>
      );
    },
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  useEffect(() => {
    getSingleProductDetails();
    getProductList();
  }, []);

  useEffect(() => {
    // defensive: ensure this runs in browser
    if (typeof window === "undefined") return;

    const handler = () => {
      const w = window.innerWidth;
      const newVal = getSlidesToShow(w);
      setSlidesToShow((prev) => (prev === newVal ? prev : newVal));
      // debug:
      // console.log("window.innerWidth", w, "slidesToShow", newVal)
    };

    // run once
    handler();
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);

  return (
    <div className="App">
      <Slider {...announcementSettings}>
        <div className="top-header">
          <p>40% OFF EVERYTHING! </p>
        </div>

        <div className="top-header">
          <p>Limited Time Free Shipping on ALL ORDERS!</p>
        </div>
      </Slider>
      <div className="banner-cover">
        {/* <Container fluid className="px-5"> */}
        <div className="banner">
          <div className="banner-overlay"></div>
          <video
            autoPlay
            loop
            muted
            playsInline
            // poster={poster}
          >
            <source src={BannerVid} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        {/* </Container> */}
      </div>
      <Container fluid className="px-lg-5">
        <div className="review-carousel">
          <Slider {...settingsReview}>
            {reviews.map((review, index) => (
              <div key={index} className="review-card">
                <div className="review-rating">
                  {"★".repeat(review.rating)}
                  {"☆".repeat(5 - review.rating)}
                </div>
                <h3 className="review-title">{review.title}</h3>
                <p className="review-text">{review.review}</p>
                <div className="review-author">
                  <span className="author-name">{review.name}</span>
                  <span className="verified">
                    {review.verified ? "Verified Buyer" : ""}
                  </span>
                </div>
              </div>
            ))}
          </Slider>
        </div>

        <div className="single-product">
          <div className="row gx-5">
            <div className="col-lg-7">
              <div className="slider-container">
                <Slider {...settingsImg}>
                  {singleProduct?.images?.edges?.map(({ node, index }) => (
                    <img src={node?.url} key={index} alt={node?.altText} />
                  ))}
                </Slider>
              </div>
            </div>
            <div className="col-lg-5 product-content">
              <h2>{singleProduct?.title}</h2>
              {/* <h4>
                US${singleProduct?.variants?.edges[0]?.node.priceV2?.amount}
              </h4> */}
              <div className="productPrice">
                {hasDiscount && (
                  <div style={{ display: "flex", alignItems: "center" }}>
                    {/* Original Price */}
                    <span
                      style={{
                        textDecoration: "line-through",
                        marginRight: "10px",
                      }}
                    >
                      ${originalPrice.toFixed(2)}
                    </span>

                    {/* Sale Price */}
                    <h4>${salePrice.toFixed(2)}</h4>

                    {/* Discount Percentage Badge */}
                    <span className="discount-badge">
                      {discountPercentage}% OFF
                    </span>
                  </div>
                )}
                {!hasDiscount && <h4>${salePrice.toFixed(2)}</h4>}
              </div>
              <p className="mb-3">
                Select Shade: <strong>{selectedColor || "Black"}</strong>
              </p>
              <ul className="list-unstyled d-flex flex-wrap">
                {singleProduct?.variants?.edges?.map(({ node }) => {
                  // assume color name is part of the variant title, e.g. "Black", "Red", etc.
                  const colorName = node.title.split(" ")[0];

                  // Optional: a simple color map for demo (use your data if available)
                  const colorMap = {
                    Black: "#000000",
                    White: "#ffffff",
                    Pink: "#FFC0CB",
                    blue: "#1a2961",
                    Green: "#269569",
                  };
                  const colorHex = colorMap[colorName] || "#ccc";

                  return (
                    <li
                      key={node.id}
                      className={`me-2 color-circle ${
                        selectedColor === colorName ? "active" : ""
                      }`}
                      onClick={() => setSelectedColor(colorName)}
                      style={{
                        width: "30px",
                        height: "30px",
                        borderRadius: "50%",
                        backgroundColor: colorHex,
                        border:
                          selectedColor === colorName
                            ? "2px solid #000"
                            : "1px solid #ddd",
                        cursor: "pointer",
                      }}
                      title={colorName}
                    ></li>
                  );
                })}
              </ul>
              <Button
                variant="dark"
                className="mb-5"
                onClick={() => {
                  if (singleProduct?.onlineStoreUrl) {
                    window.open(singleProduct.onlineStoreUrl, "_blank");
                  }
                }}
              >
                SHOP SMART SILICONE BAND
              </Button>
              <Card>
                <Card.Body>
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>Product Details</Accordion.Header>
                      <Accordion.Body>
                        <p>
                          The Smart NFC Silicone Band is the simplest way to
                          carry your digital business card on your wrist. A
                          single tap opens your Contact Co. profile so new
                          connections can save your info, follow your socials,
                          or even access your payment link — no app or
                          subscription required.
                        </p>
                        <p>
                          Every band includes one free function for life, and
                          you can upgrade to Premium or Elite if you’d like
                          multiple functions or custom fields. Made from soft,
                          waterproof silicone, it’s comfortable enough for
                          all-day wear, durable enough for workouts, and secure
                          enough for crowded events. Whether you’re at a
                          conference, trade show, or just out with friends, this
                          digital business card wristband keeps you ready to
                          connect.
                        </p>
                        <p>
                          Pair it with the free Contact Co. app for more
                          flexibility. Customize your profile, switch between
                          business and personal setups, or attach Memories -
                          personal keepsakes like photos, videos, or voice notes
                          you want to save with your wearable.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>Key Features</Accordion.Header>
                      <Accordion.Body>
                        <h4>Instant sharing</h4>
                        <p>
                          Tap the band to any smartphone to share your profile,
                          links, or files in seconds - no app required for the
                          other person.
                        </p>

                        <h4>Your digital business card</h4>
                        <p>
                          Replace stacks of paper cards with a reusable
                          wristband that’s always with you and always up to
                          date.
                        </p>

                        <h4>Event-ready design</h4>
                        <p>
                          Lightweight and durable, the silicone band is a
                          favorite for expos, trade shows, and large-scale
                          events.
                        </p>

                        <h4>Powered by Apex Core technology</h4>
                        <p>
                          Strong read range, compact build, and ready for future
                          offline mode - built to perform when it matters most.
                        </p>

                        <h4>Memories that matter</h4>
                        <p>
                          Go beyond networking by storing personal photos, vows,
                          or voice messages you want to carry with you.
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>Tech specs</Accordion.Header>
                      <Accordion.Body>
                        <p>
                          <span>Material:</span> Waterproof, hypoallergenic
                          silicone
                        </p>
                        <p>
                          <span>Apex Core™ Technology:</span> 7-byte UID, 106
                          kbit/s communication speed, fully NFC Forum Type 2 Tag
                          compliant
                        </p>
                        <p>
                          <span>Backup: </span> QR Profile code for non-NFC
                          devices managed directly in the Contact Co. app
                        </p>
                        <p>
                          <span>Durability: </span>Sweat- and water-resistant
                          for sports or events
                        </p>
                        <p>
                          <span>Power:</span> 100% passive - no charging
                          required
                        </p>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>Compatibility</Accordion.Header>
                      <Accordion.Body>
                        <ul>
                          <li>
                            <p>
                              Smartphones: Works with all NFC-enabled devices,
                              including Apple and Android smartphones
                            </p>
                          </li>
                          <li>
                            <p>
                              Fallback: Optional QR code sharing is available
                              through the app, widget, and companion tools
                            </p>
                          </li>
                          <li>
                            <p>
                              Software: No app required; customization via free
                              Contact Co. app
                            </p>
                          </li>
                        </ul>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>

        <div className="video">
          <video
            autoPlay
            loop
            muted
            playsInline
            // poster={poster}
          >
            <source src={Vid} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <Button
            variant="dark"
            className="mt-5"
            onClick={() => {
              if (singleProduct?.onlineStoreUrl) {
                window.open(singleProduct.onlineStoreUrl, "_blank");
              }
            }}
          >
            SHOP SMART SILICONE BAND
          </Button>
          <img src={Logo} alt="" />
        </div>
        <div className="faq">
          <Card>
            <Card.Body>
              <Accordion defaultActiveKey={["0"]} alwaysOpen>
                <Accordion.Item eventKey="0">
                  <Accordion.Header>Who We Are</Accordion.Header>
                  <Accordion.Body>
                    Contact Co. is a pioneer in merging style with innovation,
                    revolutionizing the way professionals and creatives connect
                    in a digital-first world. Driven by a mission to simplify
                    networking, we deliver sophisticated, elegant, and
                    cutting-edge NFC-enabled wearable devices and digital cards
                    that keep your digital identity accessible anytime,
                    anywhere.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>What We Do</Accordion.Header>
                  <Accordion.Body>
                    We design and create smart, sleek products such as the Smart
                    Silicone Band, Smart Premier Metal Card, Smart Tungsten
                    Elite Ring, and the Smart Keychain. Each item blends
                    durable, premium materials with advanced NFC technology to
                    allow instant sharing of contact information, social
                    profiles, payment links, and much more — all with a simple
                    tap or scan. Our solutions eliminate outdated paper cards,
                    providing eco-friendly, customizable, and stylish
                    alternatives.
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>How It Works</Accordion.Header>
                  <Accordion.Body>
                    Simply tap your Contact Co. wearable or card on any
                    NFC-enabled smartphone to share your profile instantly. No
                    app installation needed for the recipient. With our
                    user-friendly Contact Co. app, customize your information
                    anytime, update your digital profile seamlessly, or generate
                    QR codes for additional sharing options. Whether you're at
                    business meetings, networking events, or social gatherings,
                    your digital identity is always at your fingertips with
                    effortless, instant sharing.
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Card.Body>
          </Card>
        </div>
        <div className="video">
          <video
            autoPlay
            loop
            muted
            playsInline
            // poster={poster}
          >
            <source src={Vid2} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div className="product-list">
          <h2 className="text-center mb-1">More To Explore</h2>
          <p className="text-center mb-5">The Future Of Networking</p>
          <div className="slider-container">
            <Slider {...settings} ref={productSliderRef}>
            {productList?.map(({ node }, index) => {
  const imageUrl =
    node?.images?.edges?.[0]?.node?.url ||
    "https://via.placeholder.com/300x300?text=No+Image";

  // Access the sale price (minVariantPrice) and original price (maxVariantPrice)
  const salePrice = parseFloat(node?.priceRange?.minVariantPrice?.amount); // Sale price
  const originalPrice = parseFloat(node?.priceRange?.maxVariantPrice?.amount || salePrice); // Original price (use maxVariantPrice if available, else use salePrice as original price)

  const currency = node?.priceRange?.minVariantPrice?.currencyCode;

  // Check if there's a discount
  const hasDiscount = originalPrice > salePrice;

  // Calculate the discount percentage (if applicable)
  const discountPercentage = hasDiscount
    ? Math.round(((originalPrice - salePrice) / originalPrice) * 100)
    : 0;

 
  return (
    <Card key={index} className="p-3 text-center border-0 mx-2">
      <div className="product-card">
        <a
          href={node?.onlineStoreUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <div className="ratio ratio-1x1">
            <img src={imageUrl} alt={node?.title} />
          </div>
          <h5 className="mt-3">{node?.title}</h5>

          <div className="allProductPrice">
            {hasDiscount ? (
              // Show original price with a strike-through, sale price, and discount percentage
              <p className="text-muted mb-1">
                <span
                  style={{
                    textDecoration: "line-through",
                    marginRight: "10px",
                  }}
                >
                  {currency} ${originalPrice.toFixed(2)} {/* Original Price */}
                </span>
                <span style={{ color: "red" }}>
                  ${salePrice.toFixed(2)}{" "} {/* Sale Price */}
                  <span className="discount-badge">
                   40% OFF
                  </span>
                </span>
              </p>
            ) : (
              // If no discount, only show sale price
              <p className="text-muted mb-1">
                {currency} ${salePrice.toFixed(2)}
              </p>
            )}
          </div>
        </a>
      </div>
    </Card>
  );
})}



            </Slider>
          </div>
        </div>
        <div className="review">
          <h2 className="text-center mb-1">Let customers speak for us</h2>
          <p className="text-center mb-5">
            Used by Thousands. Trusted by Experts.
          </p>
          <div className="slider-container">
            <Slider {...settings} ref={reviewSliderRef}>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  <h5>Great Item and Super Support</h5>
                  <p className="text-muted mb-1">
                    I rank products in order of three things: (1) Practical
                    value to me as a user, (2) Price/Value (3) Support. I give
                    Contact Co 5 stars plus on all three. The "card" is cool
                    with unique backgrounds and numerous color options, the
                    performance is fast and easy, and the support is instant and
                    extremely helpful. In this day and age, you always want to
                    do business with people who are willing to spend time making
                    sure everything works as advertised, and this company checks
                    all of those boxes. Throw away all of your outdated business
                    cards and buy one (or several) of these products.
                  </p>
                  <h4>William Hammett</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  <h5>Excellent product</h5>
                  <p className="text-muted mb-1">
                    Works out well and cuts out using business cards
                  </p>
                  <h4>Mike Divers</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  {/* <h5 className="mt-3">Excellent product</h5> */}
                  <p className="text-muted mb-1">
                    Helping my team stay connected to more clients
                  </p>
                  <h4>DAVID</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  <h5>As Advertised</h5>
                  <p className="text-muted mb-1">
                    This band not only looks and fits great, each time I've used
                    it people were very impressed and wanted their own. I bought
                    the wooden bracelet and the metal card also. Highly
                    recommend this product and company. And oh, service? Add
                    exceptional customer service...a quick response when I had a
                    question or needed assistance, hard to find this level of
                    service these days, with any product or industry.
                  </p>
                  <h4>Chip Slaughter</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  {/* <h5>Excellent product</h5> */}
                  <p className="text-muted mb-1">
                    Works great. Easy to use and live the concept. Clients also
                    are impressed with how easy it is to use. Shipping was quick
                    and the app works perfect. Love the product and would highly
                    recommend!
                  </p>
                  <h4>Eric</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  <h5>Excellent</h5>
                  <p className="text-muted mb-1">
                    It was a very nice purchase, however I thought I bought the
                    Item (2) packages and I only received one, but I think it
                    was my mistake because the picture shows 2 bracelets, maybe
                    that confused me
                  </p>
                  <h4>Miguel Salazar</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  <h5>Brilliant networking fun</h5>
                  <p className="text-muted mb-1">
                    Great tool for quick connects at a large conference/venue
                    without having to take out phone or business cards! Look
                    forward to lots of additional connects because of the ease
                    of use!
                  </p>
                  <h4>Doug Peeler</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  {/* <h5>Brilliant networking fun</h5> */}
                  <p className="text-muted mb-1">It works</p>
                  <h4>k.A.</h4>
                </div>
              </Card>
              <Card className="p-3 border-0 mx-2">
                <div className="product-card">
                  <ul className="d-flex mb-4 list-unstyled">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <li key={index}>
                        <img src={star} alt={`star-${index + 1}`} />
                      </li>
                    ))}
                  </ul>

                  {/* <h5>Brilliant networking fun</h5> */}
                  <p className="text-muted mb-1">Love it & works well.</p>
                  <h4>Robert</h4>
                </div>
              </Card>
            </Slider>
          </div>
        </div>
      </Container>
    </div>
  );
}

export default App;
